<template>
  <div class='core'>
    <div class='layui-fluid'>
      <div class="Echarts statistics-charts-style">
        <div id="main1" style="width: 600px;height: 400px;"></div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import * as echarts from 'echarts';

export default {
  name: 'pieStatistics',
  data () {
    return {
      dataList: []
    }
  },
  props: {
    pieData: {
      type: Array,
      default: ()=> {
        return [];
      }
    }
  },
  mounted(){
    this.dataList = this.pieData;
    this.myEcharts();
  },
  watch: {
    pieData(value) {
      this.dataList = value
      this.myEcharts()
    },
  },
  methods: {
    myEcharts(){
      let myChart = echarts.init(document.getElementById('main1'));

      let option = {
        title: {
          text: '故障类型分布',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          left: 'center',
          top: 'bottom',
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        series: [
          {
            name: '设备类型',
            type: 'pie',
            radius: [20, 140],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 5
            },
            data: this.dataList
          }
        ]
      }

      let option1 = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.dataList
          }
        ]
      };
      myChart.setOption(option);
    }
  }
}
</script>
<style scoped>
.statistics-charts-style {
  background-color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/pieStatistics.vue